// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M13 3V6H11V3H13ZM20.4853 6.92848L18.364 9.0498L16.9497 7.63559L19.0711 5.51426L20.4853 6.92848ZM4.9289 5.51431L7.05022 7.63563L5.63601 9.04984L3.51469 6.92852L4.9289 5.51431ZM6 15V14C6 10.6863 8.68629 8 12 8C15.3137 8 18 10.6863 18 14V15C14.2177 15 12.5765 15 6 15ZM1 13H4V15H1V13ZM20 13H23V15H20V13ZM1 17H9.30278L12 18.7982L14.6972 17H23V19H15.3028L12 21.2019L8.69722 19H1V17Z"}}]};

const SunFallFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'sun-fall-filled',
    ref,
    icon: element,
  },
));

SunFallFilledIcon.displayName = 'SunFallFilledIcon';

export default SunFallFilledIcon;
